import React from "react"

const PresskitCardList = ({ marginDisabled, gridSize, children }) => (
	<section className={"presskit-card-list module-margin " + (marginDisabled ? "module-margin-disabled " : "")}>
		<div className={"grid " + (gridSize ? gridSize : "")}>{children}</div>
	</section>
)

export default PresskitCardList
